module.exports = __webpack_public_path__ + "static/img/25.3d66072.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/25.png
// module id = 0mG1
// module chunks = 0